import { GENERIC_FRIENDLY_ERROR_MESSAGE } from '../constants';

export default function getGenericFriendlyErrorMessage(component) {
    const forComponent = component ? ` for ${component}` : '';
    return [`${GENERIC_FRIENDLY_ERROR_MESSAGE}${forComponent}.`];
}
